// mn.js
export default {
  completion: '{{percent}}% бөглөсөн',
  pagesValidationProgress: '{{valid}}/{{total}} хуудас хүчинтэй ({{percent}}%)',
  pageComplete: 'Бөглөсөн',
  copyPath: 'Замыг хуулах',
  pathCopiedToClipboard: 'Замыг түр санах ойд хууллаа',
  subPage: 'Дэд хуудас',
  addChildTo: '{{nodeDefLabel}}-д нэмэх',
  addChildToTitle: '{{nodeDefLabel}}-д шинэ зангилаа нэмэх',
  addChildToTypes: {
    boolean: 'Логик',
    code: 'Код',
    coordinate: 'Координат',
    date: 'Огноо',
    decimal: 'Бутархай',
    geo: 'Байршил',
    entity: 'Объект',
    file: 'Файл',
    integer: 'Бүхэл',
    taxon: 'Ангилал',
    text: 'Текст',
    time: 'Цаг',
    // layout elements
    formHeader: 'Толгой',
  },
  clone: `'{{nodeDefLabel}}' хуулах`,
  compressFormItems: `'{{nodeDefLabel}}'-н маягтын зүйлсийг шахах`,
  confirmClearNonApplicableValues: `Дараах талбарууд хамааралгүй болж, тэдгээрийн утгыг устгана:

{{nodeDefLabels}}

Үргэлжлүүлэх үү?`,
  confirmUpdateDependentEnumeratedEntities: `Хэрэв та үргэлжлүүлбэл, зарим тоологдсон объектууд ({{entityDefs}}) дахин тоологдох болно, 
тэдгээрт оруулсан одоо байгаа утгуудыг (хэрэв байгаа бол) устгана. 
Үргэлжлүүлэх үү?`,
  convert: `'{{nodeDefLabel}}' хөрвүүлэх`,
  delete: `'{{nodeDefLabel}}' устгах`,
  edit: `'{{nodeDefLabel}}' засах`,
  schemaSummary_csv: 'Схемийн хураангуй (CSV)',
  schemaSummary_xlsx: 'Схемийн хураангуй (Excel)',
  schemaSummaryAiDescriptions_csv: 'Схемийн хураангуй + ХОС тайлбар (CSV)',
  schemaSummaryAiDescriptions_xlsx: 'Схемийн хураангуй + ХОС тайлбар (Excel)',
  hidePages: 'Хуудсыг нуух',
  showPages: 'Хуудсыг харуулах',
  move: `'{{nodeDefLabel}}' зөөх`,
  movePageUp: 'Хуудсыг дээш зөөх',
  movePageDown: 'Хуудсыг доош зөөх',
  formEditActions: {
    preview: 'Урьдчилан харах',
  },
  formEntryActions: {
    confirmDemote: 'Та энэ бичлэгийг {{name}}-д буулгахыг хүсч байгаадаа итгэлтэй байна уу?',
    confirmPromote: `Та энэ бичлэгийг **{{name}}-д дэвшүүлэхийг** хүсч байгаадаа итгэлтэй байна уу? 
Та үүнийг дахин засах боломжгүй болно`,
    confirmPromoteWithErrors: `**Энэ бичлэг алдаатай байна**.  
$t(surveyForm:formEntryActions.confirmPromote)`,
    confirmDelete: 'Та энэ бичлэгийг устгахдаа итгэлтэй байна уу?\n\n$t(common.cantUndoWarning)',
    closePreview: 'Урьдчилан харахыг хаах',
    demoteTo: '{{stepPrev}}-д буулгах',
    promoteTo: '{{stepNext}}-д дэвшүүлэх',
    step: 'Алхам {{id}} ({{name}})',
  },
  nodeDefEditFormActions: {
    columns: 'Баганууд',
    confirmConvert: 'Атрибут "{{name}}"-г "{{toType}}"-д хөрвүүлэх үү?',
    confirmDelete:
      'Та энэ зангилааны тодорхойлолтыг: {{ name }} бүрмөсөн устгахыг хүсч байгаадаа итгэлтэй байна уу?\n\nБуцаах боломжгүй анхааруулга',
  },
  nodeDefCode: {
    code: 'Код',
    label: 'Шошго',
    typeCodeOrLabel: 'Код эсвэл шошго бичих',
    option: 'Сонголт {{value}}',
  },
  nodeDefBoolean: {
    labelValue: {
      trueFalse: {
        true: 'Үнэн',
        false: 'Худал',
      },
      yesNo: {
        true: 'Тийм',
        false: 'Үгүй',
      },
    },
  },
  nodeDefCoordinate: {
    coordinate: 'Координат',
    srs: 'SRS',
    x: 'X',
    y: 'Y',
    showOnMap: 'Газрын зураг дээр харуулах',
    accuracy: 'Нарийвчлал',
    altitude: 'Өндөр',
    altitudeAccuracy: 'Өндрийн нарийвчлал',
  },
  nodeDefGeo: {
    confirmDelete: 'Энэ Газарзүйн орон зайн утгыг устгах уу?',
    geoJSON: 'GeoJSON',
    invalidGeoJsonFileUploaded: 'Буруу GeoJSON файл байршуулсан',
  },
  nodeDefEntityForm: {
    addNewEntity: 'Шинэ {{name}} нэмэх',
    confirmDelete: 'Та энэ объектыг устгахыг хүсч байгаадаа итгэлтэй байна уу?',
    select: '{{name}} сонгох:',
    selectedEntity: 'Сонгосон {{name}}:',
  },
  nodeDefTaxon: {
    code: 'Код',
    scientificName: 'Шинжлэх ухааны нэр',
    vernacularName: 'Нутаг усны нэр',
    vernacularNameAlwaysIncludedIfSingle: 'Хэрэв ганц байвал нутаг усны нэрийг үргэлж оруулах',
    vernacularNameAlwaysIncludedIfSingleInfo: `- **Идэвхтэй**: энэ сонголтыг идэвхжүүлсэн бөгөөд таксонд зөвхөн нэг нутаг усны нэр тодорхойлогдсон бол тухайн нутаг усны нэр нь таксоныг сонгох үед өгөгдөлтэй хамт автоматаар хадгалагдана.  
- **Идэвхгүй**: таксонд ганц нутаг усны нэр байсан ч зөвхөн таксоны код болон шинжлэх ухааны нэр хадгалагдана.`,
    vernacularNameSelectionKept: 'Нутаг усны нэр сонголтыг хэвээр хадгалсан',
    vernacularNameSelectionKeptInfo: `- **Идэвхтэй**: таксоныг нутаг усны (нийтлэг) нэрээр сонгох үед хайлтад ашигласан тухайн нутаг усны нэр мөн өгөгдөлд хадгалагдана.  
- **Идэвхгүй**: хайлтын үед ямар нутаг усны нэр ашигласнаас үл хамааран зөвхөн таксоны код болон шинжлэх ухааны нэр хадгалагдана.  
Arena Mobile дээр:  
- **Идэвхтэй**: нутаг усны нэр бүр хайлтын үр дүнгийн жагсаалтад тусдаа элементээр харагдана.
- **Идэвхгүй**: таксоны бүх нутаг усны нэрийг бүлэглэн таксонтой хамт (нэг мөрөнд нэгтгэн) харуулна. Үүний үр дүнд автоматаар гүйцээх жагсаалтын элементүүдийн тоо цөөрнө.`,
    visibleFields: 'Харагдах талбарууд',
  },
  nodeDefFile: {
    errorLoadingPreview: 'Урьдчилан харахыг ачаалахад алдаа гарлаа',
    fileUuid: 'Файлын uuid',
    fileName: 'Файлын нэр',
    locationInformationNotFound: 'Байршлын мэдээлэл файл дотор олдсонгүй',
  },
  nodeDefsTreeSelectMode: {
    allNodeDefs: 'Бүх зангилаа',
    onlyPages: 'Зөвхөн хуудсууд',
  },
  step: {
    entry: 'Оролт',
    cleansing: 'Цэвэрлэгээ',
    analysis: 'Шинжилгээ',
  },
  cloneFromAnotherSurvey: {
    title: 'Өөр судалгаанаас зангилааг хуулбарлах',
    expandToLoadNodes: 'Зангилааг ачаалахын тулд дэлгэнэ үү',
    loadingSurveyNodes: 'Судалгааны зангилааг ачаалж байна...',
    errorLoadingSurveyNodes: 'Судалгааны зангилааг ачаалахад алдаа гарлаа',
    noNodesAvailable: 'Зангилаа байхгүй байна',
    loadingSurveys: 'Судалгаануудыг ачаалж байна...',
    noSurveysAvailable: 'Судалгаа байхгүй байна',
    sourceNode: 'Эх зангилаа',
    targetEntityCurrentSurvey: 'Зорилтот нэгж (одоогийн судалгаа)',
  },
  confirmNodeDelete: 'Та энэ {{nodeDefType}} ({{nodeDefLabel}})-г устгахыг хүсч байгаадаа итгэлтэй байна уу?',
  downloadPrintableDocument: 'Хэвлэх баримт бичиг татах (Word)',
  downloadPrintableDocumentPdf: 'Хэвлэх баримт бичиг татах (PDF)',
  printableExport: {
    title: 'Хэвлэх боломжтой баримт бичиг экспортлох',
    exportDocument: 'Баримт бичиг экспортлох',
    format: 'Формат',
    formats: {
      pdf: 'PDF',
      docx: 'Word',
    },
    scope: 'Агуулга',
    scopes: {
      full: 'Судалгааг бүтнээр',
      currentPage: 'Зөвхөн одоогийн хуудас ({{entityLabel}})',
    },
    currentPageUnavailable:
      'Одоогийн хуудсыг тодорхойлох боломжгүй байна. Тодорхой хуудас руу шилжих эсвэл судалгааг бүтнээр нь экспортолно уу.',
    includeQrCode: 'QR код оруулах',
    includeQrCodeInfo: 'Энэ нэгжийн зөвхөн унших PDF руу холбосон QR кодыг эхний хуудсанд нэмнэ (1 жилийн хугацаатай).',
    orientation: 'Хуудасны чиглэл',
    orientations: {
      portrait: 'Босоо',
      landscape: 'Хэвтээ',
    },
    download: 'Татах',
  },
  exportLabels_csv: 'Шошгыг экспортлох (CSV)',
  exportLabels_xlsx: 'Шошгыг экспортлох (Excel)',
  importLabels: 'Шошгыг Excel эсвэл CSV-ээс импортлох',
  aiTranslateLabels: 'AI: Шошгыг орчуулах',
  nodeDefsTranslation: {
    apply: 'Орчуулга хэрэгжүүлэх',
    applySuccess: 'Орчуулга амжилттай хэрэгжлээ',
    aiSuggestion: 'AI',
    current: 'Одоогийн',
    custom: 'Захиалгат',
    defaultDescription: 'Үндсэн тайлбар',
    defaultLabel: 'Үндсэн шошго',
    path: 'Зам',
    showDescriptions: 'Тайлбар харуулах',
    title: 'Зангилааны тодорхойлолтын шошгыг орчуулах',
  },
}
